import {
  StringSerializer_getInstance2wffkbpdux3h9 as StringSerializer_getInstance,
  BooleanSerializer_getInstance1t8habeqgiyq1 as BooleanSerializer_getInstance,
  LongSerializer_getInstance194e4t3ow5wjs as LongSerializer_getInstance,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  Index19x9ylte4qic1 as Index,
  IndexSet1wbu7in7fosv3 as IndexSet,
} from '../../../lightningdb/Annotations.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../DefaultClock.mjs';
import { InstantIso8601Serializer_getInstance2sfqqbic5n1oz as InstantIso8601Serializer_getInstance } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/InstantSerializers.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  SerializerFactory1qv9hivitncuv as SerializerFactory,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getBigIntHashCode294hi5bdhtj6e as getBigIntHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { HasId2loj0ucxxxo6d as HasId } from '../../../lightningdb/HasId.mjs';
import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { INT_getInstancev41irj55hx3n as INT_getInstance } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptors.mjs';
import { NoSuchElementException679xzhnp5bpj as NoSuchElementException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function WebAuthNCredential$Companion$$childSerializers$_anonymous__l3wnlr() {
  return new (ArrayListSerializer())(StringSerializer_getInstance());
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.e2w_1 = [null, null, null, null, null, null, null, null, lazy(tmp_0, WebAuthNCredential$Companion$$childSerializers$_anonymous__l3wnlr), null, null, null, null];
      }
      k2a() {
        return $serializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance() {
  if (Companion_instance_0 === VOID)
    new (Companion())();
  return Companion_instance_0;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.proof.WebAuthNCredential', this, 13);
        tmp0_serialDesc.a1b('_id', false);
        tmp0_serialDesc.a1b('subjectId', false);
        tmp0_serialDesc.b1b(new (Index())());
        tmp0_serialDesc.a1b('subjectType', false);
        tmp0_serialDesc.b1b(new (Index())());
        tmp0_serialDesc.a1b('displayName', false);
        tmp0_serialDesc.a1b('residentKey', false);
        tmp0_serialDesc.a1b('authenticatorAttachment', false);
        tmp0_serialDesc.a1b('attestationObject', false);
        tmp0_serialDesc.a1b('lastSignCount', false);
        tmp0_serialDesc.a1b('transports', false);
        tmp0_serialDesc.a1b('establishedAt', true);
        tmp0_serialDesc.a1b('lastUsedAt', true);
        tmp0_serialDesc.a1b('expiresAt', true);
        tmp0_serialDesc.a1b('disabledAt', true);
        tmp0_serialDesc.b1b(new (Index())());
        tmp0_serialDesc.c1b(new (IndexSet())(['subjectId', 'subjectType', 'expiresAt', 'disabledAt']));
        this.n4f_1 = tmp0_serialDesc;
      }
      o4f(encoder, value) {
        var tmp0_desc = this.n4f_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance().e2w_1;
        tmp1_output.a15(tmp0_desc, 0, value.j2w_1);
        tmp1_output.a15(tmp0_desc, 1, value.k2w_1);
        tmp1_output.a15(tmp0_desc, 2, value.l2w_1);
        tmp1_output.a15(tmp0_desc, 3, value.m2w_1);
        tmp1_output.s14(tmp0_desc, 4, value.n2w_1);
        tmp1_output.a15(tmp0_desc, 5, value.o2w_1);
        tmp1_output.a15(tmp0_desc, 6, value.p2w_1);
        tmp1_output.w14(tmp0_desc, 7, value.q2w_1);
        tmp1_output.c15(tmp0_desc, 8, tmp2_cached[8].f2(), value.r2w_1);
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 9)) {
          tmp = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$0 = get_default(Companion_instance).b1m();
          tmp = !value.s2w_1.equals(tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 9, InstantIso8601Serializer_getInstance(), value.s2w_1);
        }
        if (tmp1_output.h15(tmp0_desc, 10) ? true : !(value.t2w_1 == null)) {
          tmp1_output.d15(tmp0_desc, 10, InstantIso8601Serializer_getInstance(), value.t2w_1);
        }
        if (tmp1_output.h15(tmp0_desc, 11) ? true : !(value.u2w_1 == null)) {
          tmp1_output.d15(tmp0_desc, 11, InstantIso8601Serializer_getInstance(), value.u2w_1);
        }
        if (tmp1_output.h15(tmp0_desc, 12) ? true : !(value.v2w_1 == null)) {
          tmp1_output.d15(tmp0_desc, 12, InstantIso8601Serializer_getInstance(), value.v2w_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.o4f(encoder, value instanceof WebAuthNCredential() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.n4f_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = false;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = 0n;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = null;
        var tmp15_local11 = null;
        var tmp16_local12 = null;
        var tmp17_input = decoder.l13(tmp0_desc);
        var tmp18_cached = Companion_getInstance().e2w_1;
        if (tmp17_input.a14()) {
          tmp4_local0 = tmp17_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp17_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp17_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp17_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp17_input.n13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp17_input.v13(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp17_input.v13(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp17_input.r13(tmp0_desc, 7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp17_input.x13(tmp0_desc, 8, tmp18_cached[8].f2(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp17_input.x13(tmp0_desc, 9, InstantIso8601Serializer_getInstance(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp17_input.z13(tmp0_desc, 10, InstantIso8601Serializer_getInstance(), tmp14_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          tmp15_local11 = tmp17_input.z13(tmp0_desc, 11, InstantIso8601Serializer_getInstance(), tmp15_local11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          tmp16_local12 = tmp17_input.z13(tmp0_desc, 12, InstantIso8601Serializer_getInstance(), tmp16_local12);
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp17_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp17_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp17_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp17_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp17_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp17_input.n13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp17_input.v13(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp17_input.v13(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp17_input.r13(tmp0_desc, 7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp17_input.x13(tmp0_desc, 8, tmp18_cached[8].f2(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp17_input.x13(tmp0_desc, 9, InstantIso8601Serializer_getInstance(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp17_input.z13(tmp0_desc, 10, InstantIso8601Serializer_getInstance(), tmp14_local10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              case 11:
                tmp15_local11 = tmp17_input.z13(tmp0_desc, 11, InstantIso8601Serializer_getInstance(), tmp15_local11);
                tmp3_bitMask0 = tmp3_bitMask0 | 2048;
                break;
              case 12:
                tmp16_local12 = tmp17_input.z13(tmp0_desc, 12, InstantIso8601Serializer_getInstance(), tmp16_local12);
                tmp3_bitMask0 = tmp3_bitMask0 | 4096;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp17_input.m13(tmp0_desc);
        return WebAuthNCredential().p4f(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, null);
      }
      az() {
        return this.n4f_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance().e2w_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), BooleanSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), tmp0_cached[8].f2(), InstantIso8601Serializer_getInstance(), get_nullable(InstantIso8601Serializer_getInstance()), get_nullable(InstantIso8601Serializer_getInstance()), get_nullable(InstantIso8601Serializer_getInstance())];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var WebAuthNCredentialClass;
function WebAuthNCredential() {
  if (WebAuthNCredentialClass === VOID) {
    class $ {
      constructor(_id, subjectId, subjectType, displayName, residentKey, authenticatorAttachment, attestationObject, lastSignCount, transports, establishedAt, lastUsedAt, expiresAt, disabledAt) {
        Companion_getInstance();
        var tmp;
        if (establishedAt === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance).b1m();
        } else {
          tmp = establishedAt;
        }
        establishedAt = tmp;
        lastUsedAt = lastUsedAt === VOID ? null : lastUsedAt;
        expiresAt = expiresAt === VOID ? null : expiresAt;
        disabledAt = disabledAt === VOID ? null : disabledAt;
        this.j2w_1 = _id;
        this.k2w_1 = subjectId;
        this.l2w_1 = subjectType;
        this.m2w_1 = displayName;
        this.n2w_1 = residentKey;
        this.o2w_1 = authenticatorAttachment;
        this.p2w_1 = attestationObject;
        this.q2w_1 = lastSignCount;
        this.r2w_1 = transports;
        this.s2w_1 = establishedAt;
        this.t2w_1 = lastUsedAt;
        this.u2w_1 = expiresAt;
        this.v2w_1 = disabledAt;
      }
      f40() {
        return this.j2w_1;
      }
      q4f(_id, subjectId, subjectType, displayName, residentKey, authenticatorAttachment, attestationObject, lastSignCount, transports, establishedAt, lastUsedAt, expiresAt, disabledAt) {
        return new (WebAuthNCredential())(_id, subjectId, subjectType, displayName, residentKey, authenticatorAttachment, attestationObject, lastSignCount, transports, establishedAt, lastUsedAt, expiresAt, disabledAt);
      }
      x2w(_id, subjectId, subjectType, displayName, residentKey, authenticatorAttachment, attestationObject, lastSignCount, transports, establishedAt, lastUsedAt, expiresAt, disabledAt, $super) {
        _id = _id === VOID ? this.j2w_1 : _id;
        subjectId = subjectId === VOID ? this.k2w_1 : subjectId;
        subjectType = subjectType === VOID ? this.l2w_1 : subjectType;
        displayName = displayName === VOID ? this.m2w_1 : displayName;
        residentKey = residentKey === VOID ? this.n2w_1 : residentKey;
        authenticatorAttachment = authenticatorAttachment === VOID ? this.o2w_1 : authenticatorAttachment;
        attestationObject = attestationObject === VOID ? this.p2w_1 : attestationObject;
        lastSignCount = lastSignCount === VOID ? this.q2w_1 : lastSignCount;
        transports = transports === VOID ? this.r2w_1 : transports;
        establishedAt = establishedAt === VOID ? this.s2w_1 : establishedAt;
        lastUsedAt = lastUsedAt === VOID ? this.t2w_1 : lastUsedAt;
        expiresAt = expiresAt === VOID ? this.u2w_1 : expiresAt;
        disabledAt = disabledAt === VOID ? this.v2w_1 : disabledAt;
        return $super === VOID ? this.q4f(_id, subjectId, subjectType, displayName, residentKey, authenticatorAttachment, attestationObject, lastSignCount, transports, establishedAt, lastUsedAt, expiresAt, disabledAt) : $super.q4f.call(this, _id, subjectId, subjectType, displayName, residentKey, authenticatorAttachment, attestationObject, lastSignCount, transports, establishedAt, lastUsedAt, expiresAt, disabledAt);
      }
      toString() {
        return 'WebAuthNCredential(_id=' + this.j2w_1 + ', subjectId=' + this.k2w_1 + ', subjectType=' + this.l2w_1 + ', displayName=' + this.m2w_1 + ', residentKey=' + this.n2w_1 + ', authenticatorAttachment=' + this.o2w_1 + ', attestationObject=' + this.p2w_1 + ', lastSignCount=' + this.q2w_1.toString() + ', transports=' + toString(this.r2w_1) + ', establishedAt=' + this.s2w_1.toString() + ', lastUsedAt=' + toString_0(this.t2w_1) + ', expiresAt=' + toString_0(this.u2w_1) + ', disabledAt=' + toString_0(this.v2w_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.j2w_1);
        result = imul(result, 31) + getStringHashCode(this.k2w_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.l2w_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.m2w_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.n2w_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.o2w_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.p2w_1) | 0;
        result = imul(result, 31) + getBigIntHashCode(this.q2w_1) | 0;
        result = imul(result, 31) + hashCode(this.r2w_1) | 0;
        result = imul(result, 31) + this.s2w_1.hashCode() | 0;
        result = imul(result, 31) + (this.t2w_1 == null ? 0 : this.t2w_1.hashCode()) | 0;
        result = imul(result, 31) + (this.u2w_1 == null ? 0 : this.u2w_1.hashCode()) | 0;
        result = imul(result, 31) + (this.v2w_1 == null ? 0 : this.v2w_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof WebAuthNCredential()))
          return false;
        if (!(this.j2w_1 === other.j2w_1))
          return false;
        if (!(this.k2w_1 === other.k2w_1))
          return false;
        if (!(this.l2w_1 === other.l2w_1))
          return false;
        if (!(this.m2w_1 === other.m2w_1))
          return false;
        if (!(this.n2w_1 === other.n2w_1))
          return false;
        if (!(this.o2w_1 === other.o2w_1))
          return false;
        if (!(this.p2w_1 === other.p2w_1))
          return false;
        if (!(this.q2w_1 === other.q2w_1))
          return false;
        if (!equals(this.r2w_1, other.r2w_1))
          return false;
        if (!this.s2w_1.equals(other.s2w_1))
          return false;
        if (!equals(this.t2w_1, other.t2w_1))
          return false;
        if (!equals(this.u2w_1, other.u2w_1))
          return false;
        if (!equals(this.v2w_1, other.v2w_1))
          return false;
        return true;
      }
      static p4f(seen0, _id, subjectId, subjectType, displayName, residentKey, authenticatorAttachment, attestationObject, lastSignCount, transports, establishedAt, lastUsedAt, expiresAt, disabledAt, serializationConstructorMarker) {
        Companion_getInstance();
        if (!(511 === (511 & seen0))) {
          throwMissingFieldException(seen0, 511, $serializer_getInstance().n4f_1);
        }
        var $this = createThis(this);
        $this.j2w_1 = _id;
        $this.k2w_1 = subjectId;
        $this.l2w_1 = subjectType;
        $this.m2w_1 = displayName;
        $this.n2w_1 = residentKey;
        $this.o2w_1 = authenticatorAttachment;
        $this.p2w_1 = attestationObject;
        $this.q2w_1 = lastSignCount;
        $this.r2w_1 = transports;
        if (0 === (seen0 & 512)) {
          var tmp = $this;
          // Inline function 'com.lightningkite.now' call
          tmp.s2w_1 = get_default(Companion_instance).b1m();
        } else
          $this.s2w_1 = establishedAt;
        if (0 === (seen0 & 1024))
          $this.t2w_1 = null;
        else
          $this.t2w_1 = lastUsedAt;
        if (0 === (seen0 & 2048))
          $this.u2w_1 = null;
        else
          $this.u2w_1 = expiresAt;
        if (0 === (seen0 & 4096))
          $this.v2w_1 = null;
        else
          $this.v2w_1 = disabledAt;
        return $this;
      }
    }
    initMetadataForClass($, 'WebAuthNCredential', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance});
    WebAuthNCredentialClass = $;
  }
  return WebAuthNCredentialClass;
}
var PublicKeyAlgorithm_RS256_instance;
var PublicKeyAlgorithm_ES256_instance;
var PublicKeyAlgorithm_EdDSA_instance;
var PublicKeyAlgorithm_PS256_instance;
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      k2a() {
        return PublicKeyAlgorithmSerializer_getInstance();
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_1;
function Companion_getInstance_0() {
  return Companion_instance_1;
}
function values() {
  return [PublicKeyAlgorithm_RS256_getInstance(), PublicKeyAlgorithm_ES256_getInstance(), PublicKeyAlgorithm_EdDSA_getInstance(), PublicKeyAlgorithm_PS256_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var PublicKeyAlgorithm_entriesInitialized;
function PublicKeyAlgorithm_initEntries() {
  if (PublicKeyAlgorithm_entriesInitialized)
    return Unit_instance;
  PublicKeyAlgorithm_entriesInitialized = true;
  PublicKeyAlgorithm_RS256_instance = PublicKeyAlgorithm().u4f('RS256', 0, -257);
  PublicKeyAlgorithm_ES256_instance = PublicKeyAlgorithm().u4f('ES256', 1, -7);
  PublicKeyAlgorithm_EdDSA_instance = PublicKeyAlgorithm().u4f('EdDSA', 2, -8);
  PublicKeyAlgorithm_PS256_instance = PublicKeyAlgorithm().u4f('PS256', 3, -37);
}
var $ENTRIES;
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      k2a() {
        return $serializer_getInstance_0();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_2;
function Companion_getInstance_1() {
  return Companion_instance_2;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.proof.WebAuthN.PublicKeyCredentialParameters', this, 2);
        tmp0_serialDesc.a1b('alg', false);
        tmp0_serialDesc.a1b('type', true);
        this.v4f_1 = tmp0_serialDesc;
      }
      w4f(encoder, value) {
        var tmp0_desc = this.v4f_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.c15(tmp0_desc, 0, PublicKeyAlgorithmSerializer_getInstance(), value.x4f_1);
        tmp1_output.a15(tmp0_desc, 1, value.y4f_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.w4f(encoder, value instanceof PublicKeyCredentialParameters() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.v4f_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, PublicKeyAlgorithmSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, PublicKeyAlgorithmSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return PublicKeyCredentialParameters().z4f(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.v4f_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [PublicKeyAlgorithmSerializer_getInstance(), StringSerializer_getInstance()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_0())();
  return $serializer_instance_0;
}
function _get_$cachedSerializer__te6jhj($this) {
  return $this.i3j_1.f2();
}
function WebAuthN$Attestation$Companion$_anonymous__h6nvip() {
  return createSimpleEnumSerializer('com.lightningkite.lightningserver.auth.proof.WebAuthN.Attestation', values_0());
}
var Attestation_None_instance;
var Attestation_Direct_instance;
var Attestation_Enterprise_instance;
var Attestation_Indirect_instance;
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {
      constructor() {
        Companion_instance_3 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.i3j_1 = lazy(tmp_0, WebAuthN$Attestation$Companion$_anonymous__h6nvip);
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_3;
function Companion_getInstance_2() {
  Attestation_initEntries();
  if (Companion_instance_3 === VOID)
    new (Companion_2())();
  return Companion_instance_3;
}
function values_0() {
  return [Attestation_None_getInstance(), Attestation_Direct_getInstance(), Attestation_Enterprise_getInstance(), Attestation_Indirect_getInstance()];
}
var Attestation_entriesInitialized;
function Attestation_initEntries() {
  if (Attestation_entriesInitialized)
    return Unit_instance;
  Attestation_entriesInitialized = true;
  Attestation_None_instance = Attestation().d4g('None', 0, 'none');
  Attestation_Direct_instance = Attestation().d4g('Direct', 1, 'direct');
  Attestation_Enterprise_instance = Attestation().d4g('Enterprise', 2, 'enterprise');
  Attestation_Indirect_instance = Attestation().d4g('Indirect', 3, 'indirect');
  Companion_getInstance_2();
}
function _get_$cachedSerializer__te6jhj_0($this) {
  return $this.j3j_1.f2();
}
function WebAuthN$GeneralPreference$Companion$_anonymous__2q2k8y() {
  return createSimpleEnumSerializer('com.lightningkite.lightningserver.auth.proof.WebAuthN.GeneralPreference', values_1());
}
var GeneralPreference_Discouraged_instance;
var GeneralPreference_Preferred_instance;
var GeneralPreference_Required_instance;
var CompanionClass_3;
function Companion_3() {
  if (CompanionClass_3 === VOID) {
    class $ {
      constructor() {
        Companion_instance_4 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.j3j_1 = lazy(tmp_0, WebAuthN$GeneralPreference$Companion$_anonymous__2q2k8y);
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj_0(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_3 = $;
  }
  return CompanionClass_3;
}
var Companion_instance_4;
function Companion_getInstance_3() {
  GeneralPreference_initEntries();
  if (Companion_instance_4 === VOID)
    new (Companion_3())();
  return Companion_instance_4;
}
function values_1() {
  return [GeneralPreference_Discouraged_getInstance(), GeneralPreference_Preferred_getInstance(), GeneralPreference_Required_getInstance()];
}
var GeneralPreference_entriesInitialized;
function GeneralPreference_initEntries() {
  if (GeneralPreference_entriesInitialized)
    return Unit_instance;
  GeneralPreference_entriesInitialized = true;
  GeneralPreference_Discouraged_instance = GeneralPreference().h4g('Discouraged', 0, 'discouraged');
  GeneralPreference_Preferred_instance = GeneralPreference().h4g('Preferred', 1, 'preferred');
  GeneralPreference_Required_instance = GeneralPreference().h4g('Required', 2, 'required');
  Companion_getInstance_3();
}
function _get_$cachedSerializer__te6jhj_1($this) {
  return $this.k3j_1.f2();
}
function WebAuthN$AuthenticatorAttachment$Companion$_anonymous__5nynjf() {
  return createSimpleEnumSerializer('com.lightningkite.lightningserver.auth.proof.WebAuthN.AuthenticatorAttachment', values_2());
}
var AuthenticatorAttachment_Platform_instance;
var AuthenticatorAttachment_CrossPlatform_instance;
var CompanionClass_4;
function Companion_4() {
  if (CompanionClass_4 === VOID) {
    class $ {
      constructor() {
        Companion_instance_5 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.k3j_1 = lazy(tmp_0, WebAuthN$AuthenticatorAttachment$Companion$_anonymous__5nynjf);
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj_1(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_4 = $;
  }
  return CompanionClass_4;
}
var Companion_instance_5;
function Companion_getInstance_4() {
  AuthenticatorAttachment_initEntries();
  if (Companion_instance_5 === VOID)
    new (Companion_4())();
  return Companion_instance_5;
}
function values_2() {
  return [AuthenticatorAttachment_Platform_getInstance(), AuthenticatorAttachment_CrossPlatform_getInstance()];
}
var AuthenticatorAttachment_entriesInitialized;
function AuthenticatorAttachment_initEntries() {
  if (AuthenticatorAttachment_entriesInitialized)
    return Unit_instance;
  AuthenticatorAttachment_entriesInitialized = true;
  AuthenticatorAttachment_Platform_instance = AuthenticatorAttachment().l4g('Platform', 0, 'platform');
  AuthenticatorAttachment_CrossPlatform_instance = AuthenticatorAttachment().l4g('CrossPlatform', 1, 'cross-platform');
  Companion_getInstance_4();
}
function _get_$cachedSerializer__te6jhj_2($this) {
  return $this.l3j_1.f2();
}
function WebAuthN$Transport$Companion$_anonymous__3e6jew() {
  return createSimpleEnumSerializer('com.lightningkite.lightningserver.auth.proof.WebAuthN.Transport', values_3());
}
var Transport_BLE_instance;
var Transport_Hybrid_instance;
var Transport_Internal_instance;
var Transport_NFC_instance;
var Transport_USB_instance;
var CompanionClass_5;
function Companion_5() {
  if (CompanionClass_5 === VOID) {
    class $ {
      constructor() {
        Companion_instance_6 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.l3j_1 = lazy(tmp_0, WebAuthN$Transport$Companion$_anonymous__3e6jew);
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj_2(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_5 = $;
  }
  return CompanionClass_5;
}
var Companion_instance_6;
function Companion_getInstance_5() {
  Transport_initEntries();
  if (Companion_instance_6 === VOID)
    new (Companion_5())();
  return Companion_instance_6;
}
function values_3() {
  return [Transport_BLE_getInstance(), Transport_Hybrid_getInstance(), Transport_Internal_getInstance(), Transport_NFC_getInstance(), Transport_USB_getInstance()];
}
var Transport_entriesInitialized;
function Transport_initEntries() {
  if (Transport_entriesInitialized)
    return Unit_instance;
  Transport_entriesInitialized = true;
  Transport_BLE_instance = Transport().p4g('BLE', 0, 'ble');
  Transport_Hybrid_instance = Transport().p4g('Hybrid', 1, 'hybrid');
  Transport_Internal_instance = Transport().p4g('Internal', 2, 'internal');
  Transport_NFC_instance = Transport().p4g('NFC', 3, 'nfc');
  Transport_USB_instance = Transport().p4g('USB', 4, 'usb');
  Companion_getInstance_5();
}
function WebAuthN$ExistingCredential$Companion$$childSerializers$_anonymous__qau40m() {
  return new (ArrayListSerializer())(Companion_getInstance_5().k2a());
}
var CompanionClass_6;
function Companion_6() {
  if (CompanionClass_6 === VOID) {
    class $ {
      constructor() {
        Companion_instance_7 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.m3j_1 = [null, lazy(tmp_0, WebAuthN$ExistingCredential$Companion$$childSerializers$_anonymous__qau40m), null];
      }
      k2a() {
        return $serializer_getInstance_1();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_6 = $;
  }
  return CompanionClass_6;
}
var Companion_instance_7;
function Companion_getInstance_6() {
  if (Companion_instance_7 === VOID)
    new (Companion_6())();
  return Companion_instance_7;
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.proof.WebAuthN.ExistingCredential', this, 3);
        tmp0_serialDesc.a1b('id', false);
        tmp0_serialDesc.a1b('transports', true);
        tmp0_serialDesc.a1b('type', true);
        this.q4g_1 = tmp0_serialDesc;
      }
      r4g(encoder, value) {
        var tmp0_desc = this.q4g_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_6().m3j_1;
        tmp1_output.a15(tmp0_desc, 0, value.s4g_1);
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !equals(value.t4g_1, emptyList())) {
          tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.t4g_1);
        }
        tmp1_output.a15(tmp0_desc, 2, value.u4g_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.r4g(encoder, value instanceof ExistingCredential() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.q4g_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.l13(tmp0_desc);
        var tmp8_cached = Companion_getInstance_6().m3j_1;
        if (tmp7_input.a14()) {
          tmp4_local0 = tmp7_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.x13(tmp0_desc, 1, tmp8_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.x13(tmp0_desc, 1, tmp8_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp7_input.m13(tmp0_desc);
        return ExistingCredential().v4g(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      az() {
        return this.q4g_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_6().m3j_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), tmp0_cached[1].f2(), StringSerializer_getInstance()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var $serializer_instance_1;
function $serializer_getInstance_1() {
  if ($serializer_instance_1 === VOID)
    new ($serializer_1())();
  return $serializer_instance_1;
}
function WebAuthN$AuthenticatorSelectionOptions$Companion$$childSerializers$_anonymous__u2fu4p() {
  return Companion_getInstance_4().k2a();
}
function WebAuthN$AuthenticatorSelectionOptions$Companion$$childSerializers$_anonymous__u2fu4p_0() {
  return Companion_getInstance_3().k2a();
}
var CompanionClass_7;
function Companion_7() {
  if (CompanionClass_7 === VOID) {
    class $ {
      constructor() {
        Companion_instance_8 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, WebAuthN$AuthenticatorSelectionOptions$Companion$$childSerializers$_anonymous__u2fu4p);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.n3j_1 = [tmp_1, lazy(tmp_2, WebAuthN$AuthenticatorSelectionOptions$Companion$$childSerializers$_anonymous__u2fu4p_0)];
      }
      k2a() {
        return $serializer_getInstance_2();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_7 = $;
  }
  return CompanionClass_7;
}
var Companion_instance_8;
function Companion_getInstance_7() {
  if (Companion_instance_8 === VOID)
    new (Companion_7())();
  return Companion_instance_8;
}
var $serializerClass_2;
function $serializer_2() {
  if ($serializerClass_2 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_2 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.proof.WebAuthN.AuthenticatorSelectionOptions', this, 2);
        tmp0_serialDesc.a1b('authenticatorAttachment', true);
        tmp0_serialDesc.a1b('userVerification', true);
        this.w4g_1 = tmp0_serialDesc;
      }
      x4g(encoder, value) {
        var tmp0_desc = this.w4g_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_7().n3j_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !(value.y4g_1 == null)) {
          tmp1_output.d15(tmp0_desc, 0, tmp2_cached[0].f2(), value.y4g_1);
        }
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !value.z4g_1.equals(GeneralPreference_Preferred_getInstance())) {
          tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.z4g_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.x4g(encoder, value instanceof AuthenticatorSelectionOptions() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.w4g_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        var tmp7_cached = Companion_getInstance_7().n3j_1;
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.z13(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.x13(tmp0_desc, 1, tmp7_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.z13(tmp0_desc, 0, tmp7_cached[0].f2(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.x13(tmp0_desc, 1, tmp7_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return AuthenticatorSelectionOptions().a4h(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.w4g_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_7().n3j_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [get_nullable(tmp0_cached[0].f2()), tmp0_cached[1].f2()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_2 = $;
  }
  return $serializerClass_2;
}
var $serializer_instance_2;
function $serializer_getInstance_2() {
  if ($serializer_instance_2 === VOID)
    new ($serializer_2())();
  return $serializer_instance_2;
}
function _get_$cachedSerializer__te6jhj_3($this) {
  return $this.o3j_1.f2();
}
function WebAuthN$Hints$Companion$_anonymous__6o1mfp() {
  return createSimpleEnumSerializer('com.lightningkite.lightningserver.auth.proof.WebAuthN.Hints', values_4());
}
var Hints_SecurityKey_instance;
var Hints_ClientDevice_instance;
var Hints_Hybrid_instance;
var CompanionClass_8;
function Companion_8() {
  if (CompanionClass_8 === VOID) {
    class $ {
      constructor() {
        Companion_instance_9 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.o3j_1 = lazy(tmp_0, WebAuthN$Hints$Companion$_anonymous__6o1mfp);
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj_3(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_8 = $;
  }
  return CompanionClass_8;
}
var Companion_instance_9;
function Companion_getInstance_8() {
  Hints_initEntries();
  if (Companion_instance_9 === VOID)
    new (Companion_8())();
  return Companion_instance_9;
}
function values_4() {
  return [Hints_SecurityKey_getInstance(), Hints_ClientDevice_getInstance(), Hints_Hybrid_getInstance()];
}
var Hints_entriesInitialized;
function Hints_initEntries() {
  if (Hints_entriesInitialized)
    return Unit_instance;
  Hints_entriesInitialized = true;
  Hints_SecurityKey_instance = Hints().e4h('SecurityKey', 0, 'security-key');
  Hints_ClientDevice_instance = Hints().e4h('ClientDevice', 1, 'client-device');
  Hints_Hybrid_instance = Hints().e4h('Hybrid', 2, 'hybrid');
  Companion_getInstance_8();
}
var CompanionClass_9;
function Companion_9() {
  if (CompanionClass_9 === VOID) {
    class $ {
      k2a() {
        return $serializer_getInstance_3();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_9 = $;
  }
  return CompanionClass_9;
}
var Companion_instance_10;
function Companion_getInstance_9() {
  return Companion_instance_10;
}
var $serializerClass_3;
function $serializer_3() {
  if ($serializerClass_3 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_3 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.proof.WebAuthN.PublicKeyCredentialUserEntity', this, 3);
        tmp0_serialDesc.a1b('displayName', false);
        tmp0_serialDesc.a1b('id', false);
        tmp0_serialDesc.a1b('name', false);
        this.f4h_1 = tmp0_serialDesc;
      }
      g4h(encoder, value) {
        var tmp0_desc = this.f4h_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.a15(tmp0_desc, 0, value.h4h_1);
        tmp1_output.a15(tmp0_desc, 1, value.i4h_1);
        tmp1_output.a15(tmp0_desc, 2, value.j4h_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.g4h(encoder, value instanceof PublicKeyCredentialUserEntity() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.f4h_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.l13(tmp0_desc);
        if (tmp7_input.a14()) {
          tmp4_local0 = tmp7_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp7_input.m13(tmp0_desc);
        return PublicKeyCredentialUserEntity().k4h(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      az() {
        return this.f4h_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_3 = $;
  }
  return $serializerClass_3;
}
var $serializer_instance_3;
function $serializer_getInstance_3() {
  if ($serializer_instance_3 === VOID)
    new ($serializer_3())();
  return $serializer_instance_3;
}
var CompanionClass_10;
function Companion_10() {
  if (CompanionClass_10 === VOID) {
    class $ {
      k2a() {
        return $serializer_getInstance_4();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_10 = $;
  }
  return CompanionClass_10;
}
var Companion_instance_11;
function Companion_getInstance_10() {
  return Companion_instance_11;
}
var $serializerClass_4;
function $serializer_4() {
  if ($serializerClass_4 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_4 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.proof.WebAuthN.ClientData', this, 4);
        tmp0_serialDesc.a1b('challenge', false);
        tmp0_serialDesc.a1b('origin', false);
        tmp0_serialDesc.a1b('crossOrigin', false);
        tmp0_serialDesc.a1b('type', false);
        this.l4h_1 = tmp0_serialDesc;
      }
      m4h(encoder, value) {
        var tmp0_desc = this.l4h_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.a15(tmp0_desc, 0, value.n4h_1);
        tmp1_output.a15(tmp0_desc, 1, value.o4h_1);
        tmp1_output.s14(tmp0_desc, 2, value.p4h_1);
        tmp1_output.a15(tmp0_desc, 3, value.q4h_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.m4h(encoder, value instanceof ClientData() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.l4h_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = false;
        var tmp7_local3 = null;
        var tmp8_input = decoder.l13(tmp0_desc);
        if (tmp8_input.a14()) {
          tmp4_local0 = tmp8_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp8_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp8_input.n13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp8_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp8_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp8_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp8_input.n13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp8_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp8_input.m13(tmp0_desc);
        return ClientData().r4h(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      az() {
        return this.l4h_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance(), BooleanSerializer_getInstance(), StringSerializer_getInstance()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_4 = $;
  }
  return $serializerClass_4;
}
var $serializer_instance_4;
function $serializer_getInstance_4() {
  if ($serializer_instance_4 === VOID)
    new ($serializer_4())();
  return $serializer_instance_4;
}
var PublicKeyAlgorithmClass;
function PublicKeyAlgorithm() {
  if (PublicKeyAlgorithmClass === VOID) {
    class $ extends Enum() {
      static u4f(name, ordinal, coseAlgorithmId) {
        var $this = this.c4(name, ordinal);
        $this.t4f_1 = coseAlgorithmId;
        return $this;
      }
    }
    initMetadataForClass($, 'PublicKeyAlgorithm', VOID, VOID, VOID, VOID, VOID, {0: PublicKeyAlgorithmSerializer_getInstance});
    PublicKeyAlgorithmClass = $;
  }
  return PublicKeyAlgorithmClass;
}
var PublicKeyAlgorithmSerializerClass;
function PublicKeyAlgorithmSerializer() {
  if (PublicKeyAlgorithmSerializerClass === VOID) {
    class $ {
      constructor() {
        PublicKeyAlgorithmSerializer_instance = this;
        this.s4h_1 = PrimitiveSerialDescriptor('PublicKeyAlgorithm', INT_getInstance());
      }
      az() {
        return this.s4h_1;
      }
      t4h(encoder, value) {
        encoder.k14(value.t4f_1);
      }
      oz(encoder, value) {
        return this.t4h(encoder, value instanceof PublicKeyAlgorithm() ? value : THROW_CCE());
      }
      pz(decoder) {
        var coseAlgorithmId = decoder.c13();
        var tmp0 = get_entries();
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.first' call
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (element.t4f_1 === coseAlgorithmId) {
              tmp$ret$1 = element;
              break $l$block;
            }
          }
          throw NoSuchElementException().o('Collection contains no element matching the predicate.');
        }
        return tmp$ret$1;
      }
    }
    initMetadataForObject($, 'PublicKeyAlgorithmSerializer', VOID, VOID, [KSerializer()]);
    PublicKeyAlgorithmSerializerClass = $;
  }
  return PublicKeyAlgorithmSerializerClass;
}
var PublicKeyAlgorithmSerializer_instance;
function PublicKeyAlgorithmSerializer_getInstance() {
  if (PublicKeyAlgorithmSerializer_instance === VOID)
    new (PublicKeyAlgorithmSerializer())();
  return PublicKeyAlgorithmSerializer_instance;
}
var PublicKeyCredentialParametersClass;
function PublicKeyCredentialParameters() {
  if (PublicKeyCredentialParametersClass === VOID) {
    class $ {
      toString() {
        return 'PublicKeyCredentialParameters(alg=' + this.x4f_1.toString() + ')';
      }
      hashCode() {
        return this.x4f_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PublicKeyCredentialParameters()))
          return false;
        if (!this.x4f_1.equals(other.x4f_1))
          return false;
        return true;
      }
      static z4f(seen0, alg, type, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_0().v4f_1);
        }
        var $this = createThis(this);
        $this.x4f_1 = alg;
        if (0 === (seen0 & 2))
          $this.y4f_1 = 'public-key';
        else
          $this.y4f_1 = type;
        return $this;
      }
    }
    initMetadataForClass($, 'PublicKeyCredentialParameters', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
    PublicKeyCredentialParametersClass = $;
  }
  return PublicKeyCredentialParametersClass;
}
var AttestationClass;
function Attestation() {
  if (AttestationClass === VOID) {
    class $ extends Enum() {
      static d4g(name, ordinal, standardName) {
        var $this = this.c4(name, ordinal);
        $this.c4g_1 = standardName;
        return $this;
      }
    }
    initMetadataForClass($, 'Attestation', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_2});
    AttestationClass = $;
  }
  return AttestationClass;
}
var GeneralPreferenceClass;
function GeneralPreference() {
  if (GeneralPreferenceClass === VOID) {
    class $ extends Enum() {
      static h4g(name, ordinal, standardName) {
        var $this = this.c4(name, ordinal);
        $this.g4g_1 = standardName;
        return $this;
      }
    }
    initMetadataForClass($, 'GeneralPreference', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_3});
    GeneralPreferenceClass = $;
  }
  return GeneralPreferenceClass;
}
var AuthenticatorAttachmentClass;
function AuthenticatorAttachment() {
  if (AuthenticatorAttachmentClass === VOID) {
    class $ extends Enum() {
      static l4g(name, ordinal, standardName) {
        var $this = this.c4(name, ordinal);
        $this.k4g_1 = standardName;
        return $this;
      }
    }
    initMetadataForClass($, 'AuthenticatorAttachment', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_4});
    AuthenticatorAttachmentClass = $;
  }
  return AuthenticatorAttachmentClass;
}
var TransportClass;
function Transport() {
  if (TransportClass === VOID) {
    class $ extends Enum() {
      static p4g(name, ordinal, standardName) {
        var $this = this.c4(name, ordinal);
        $this.o4g_1 = standardName;
        return $this;
      }
    }
    initMetadataForClass($, 'Transport', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_5});
    TransportClass = $;
  }
  return TransportClass;
}
var ExistingCredentialClass;
function ExistingCredential() {
  if (ExistingCredentialClass === VOID) {
    class $ {
      toString() {
        return 'ExistingCredential(id=' + this.s4g_1 + ', transports=' + toString(this.t4g_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.s4g_1);
        result = imul(result, 31) + hashCode(this.t4g_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ExistingCredential()))
          return false;
        if (!(this.s4g_1 === other.s4g_1))
          return false;
        if (!equals(this.t4g_1, other.t4g_1))
          return false;
        return true;
      }
      static v4g(seen0, id, transports, type, serializationConstructorMarker) {
        Companion_getInstance_6();
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_1().q4g_1);
        }
        var $this = createThis(this);
        $this.s4g_1 = id;
        if (0 === (seen0 & 2))
          $this.t4g_1 = emptyList();
        else
          $this.t4g_1 = transports;
        if (0 === (seen0 & 4))
          $this.u4g_1 = 'public-key';
        else
          $this.u4g_1 = type;
        return $this;
      }
    }
    initMetadataForClass($, 'ExistingCredential', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
    ExistingCredentialClass = $;
  }
  return ExistingCredentialClass;
}
var AuthenticatorSelectionOptionsClass;
function AuthenticatorSelectionOptions() {
  if (AuthenticatorSelectionOptionsClass === VOID) {
    class $ {
      constructor(authenticatorAttachment, userVerification) {
        Companion_getInstance_7();
        authenticatorAttachment = authenticatorAttachment === VOID ? null : authenticatorAttachment;
        userVerification = userVerification === VOID ? GeneralPreference_Preferred_getInstance() : userVerification;
        this.y4g_1 = authenticatorAttachment;
        this.z4g_1 = userVerification;
      }
      toString() {
        return 'AuthenticatorSelectionOptions(authenticatorAttachment=' + toString_0(this.y4g_1) + ', userVerification=' + this.z4g_1.toString() + ')';
      }
      hashCode() {
        var result = this.y4g_1 == null ? 0 : this.y4g_1.hashCode();
        result = imul(result, 31) + this.z4g_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AuthenticatorSelectionOptions()))
          return false;
        if (!equals(this.y4g_1, other.y4g_1))
          return false;
        if (!this.z4g_1.equals(other.z4g_1))
          return false;
        return true;
      }
      static a4h(seen0, authenticatorAttachment, userVerification, serializationConstructorMarker) {
        Companion_getInstance_7();
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, $serializer_getInstance_2().w4g_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.y4g_1 = null;
        else
          $this.y4g_1 = authenticatorAttachment;
        if (0 === (seen0 & 2))
          $this.z4g_1 = GeneralPreference_Preferred_getInstance();
        else
          $this.z4g_1 = userVerification;
        return $this;
      }
    }
    initMetadataForClass($, 'AuthenticatorSelectionOptions', AuthenticatorSelectionOptions, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_2});
    AuthenticatorSelectionOptionsClass = $;
  }
  return AuthenticatorSelectionOptionsClass;
}
var HintsClass;
function Hints() {
  if (HintsClass === VOID) {
    class $ extends Enum() {
      static e4h(name, ordinal, standardName) {
        var $this = this.c4(name, ordinal);
        $this.d4h_1 = standardName;
        return $this;
      }
    }
    initMetadataForClass($, 'Hints', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_8});
    HintsClass = $;
  }
  return HintsClass;
}
var PublicKeyCredentialUserEntityClass;
function PublicKeyCredentialUserEntity() {
  if (PublicKeyCredentialUserEntityClass === VOID) {
    class $ {
      toString() {
        return 'PublicKeyCredentialUserEntity(displayName=' + this.h4h_1 + ', id=' + this.i4h_1 + ', name=' + this.j4h_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.h4h_1);
        result = imul(result, 31) + getStringHashCode(this.i4h_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.j4h_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PublicKeyCredentialUserEntity()))
          return false;
        if (!(this.h4h_1 === other.h4h_1))
          return false;
        if (!(this.i4h_1 === other.i4h_1))
          return false;
        if (!(this.j4h_1 === other.j4h_1))
          return false;
        return true;
      }
      static k4h(seen0, displayName, id, name, serializationConstructorMarker) {
        if (!(7 === (7 & seen0))) {
          throwMissingFieldException(seen0, 7, $serializer_getInstance_3().f4h_1);
        }
        var $this = createThis(this);
        $this.h4h_1 = displayName;
        $this.i4h_1 = id;
        $this.j4h_1 = name;
        return $this;
      }
    }
    initMetadataForClass($, 'PublicKeyCredentialUserEntity', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_3});
    PublicKeyCredentialUserEntityClass = $;
  }
  return PublicKeyCredentialUserEntityClass;
}
var ClientDataClass;
function ClientData() {
  if (ClientDataClass === VOID) {
    class $ {
      toString() {
        return 'ClientData(challenge=' + this.n4h_1 + ', origin=' + this.o4h_1 + ', crossOrigin=' + this.p4h_1 + ', type=' + this.q4h_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.n4h_1);
        result = imul(result, 31) + getStringHashCode(this.o4h_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.p4h_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.q4h_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ClientData()))
          return false;
        if (!(this.n4h_1 === other.n4h_1))
          return false;
        if (!(this.o4h_1 === other.o4h_1))
          return false;
        if (!(this.p4h_1 === other.p4h_1))
          return false;
        if (!(this.q4h_1 === other.q4h_1))
          return false;
        return true;
      }
      static r4h(seen0, challenge, origin, crossOrigin, type, serializationConstructorMarker) {
        if (!(15 === (15 & seen0))) {
          throwMissingFieldException(seen0, 15, $serializer_getInstance_4().l4h_1);
        }
        var $this = createThis(this);
        $this.n4h_1 = challenge;
        $this.o4h_1 = origin;
        $this.p4h_1 = crossOrigin;
        $this.q4h_1 = type;
        return $this;
      }
    }
    initMetadataForClass($, 'ClientData', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_4});
    ClientDataClass = $;
  }
  return ClientDataClass;
}
function PublicKeyAlgorithm_RS256_getInstance() {
  PublicKeyAlgorithm_initEntries();
  return PublicKeyAlgorithm_RS256_instance;
}
function PublicKeyAlgorithm_ES256_getInstance() {
  PublicKeyAlgorithm_initEntries();
  return PublicKeyAlgorithm_ES256_instance;
}
function PublicKeyAlgorithm_EdDSA_getInstance() {
  PublicKeyAlgorithm_initEntries();
  return PublicKeyAlgorithm_EdDSA_instance;
}
function PublicKeyAlgorithm_PS256_getInstance() {
  PublicKeyAlgorithm_initEntries();
  return PublicKeyAlgorithm_PS256_instance;
}
function Attestation_None_getInstance() {
  Attestation_initEntries();
  return Attestation_None_instance;
}
function Attestation_Direct_getInstance() {
  Attestation_initEntries();
  return Attestation_Direct_instance;
}
function Attestation_Enterprise_getInstance() {
  Attestation_initEntries();
  return Attestation_Enterprise_instance;
}
function Attestation_Indirect_getInstance() {
  Attestation_initEntries();
  return Attestation_Indirect_instance;
}
function GeneralPreference_Discouraged_getInstance() {
  GeneralPreference_initEntries();
  return GeneralPreference_Discouraged_instance;
}
function GeneralPreference_Preferred_getInstance() {
  GeneralPreference_initEntries();
  return GeneralPreference_Preferred_instance;
}
function GeneralPreference_Required_getInstance() {
  GeneralPreference_initEntries();
  return GeneralPreference_Required_instance;
}
function AuthenticatorAttachment_Platform_getInstance() {
  AuthenticatorAttachment_initEntries();
  return AuthenticatorAttachment_Platform_instance;
}
function AuthenticatorAttachment_CrossPlatform_getInstance() {
  AuthenticatorAttachment_initEntries();
  return AuthenticatorAttachment_CrossPlatform_instance;
}
function Transport_BLE_getInstance() {
  Transport_initEntries();
  return Transport_BLE_instance;
}
function Transport_Hybrid_getInstance() {
  Transport_initEntries();
  return Transport_Hybrid_instance;
}
function Transport_Internal_getInstance() {
  Transport_initEntries();
  return Transport_Internal_instance;
}
function Transport_NFC_getInstance() {
  Transport_initEntries();
  return Transport_NFC_instance;
}
function Transport_USB_getInstance() {
  Transport_initEntries();
  return Transport_USB_instance;
}
function Hints_SecurityKey_getInstance() {
  Hints_initEntries();
  return Hints_SecurityKey_instance;
}
function Hints_ClientDevice_getInstance() {
  Hints_initEntries();
  return Hints_ClientDevice_instance;
}
function Hints_Hybrid_getInstance() {
  Hints_initEntries();
  return Hints_Hybrid_instance;
}
//region block: init
Companion_instance_1 = new (Companion_0())();
Companion_instance_2 = new (Companion_1())();
Companion_instance_10 = new (Companion_9())();
Companion_instance_11 = new (Companion_10())();
//endregion
//region block: exports
export {
  WebAuthNCredential as WebAuthNCredentialoa2waq5o0kvs,
  Companion_getInstance_2 as Companion_getInstance2t29tjgmmdesl,
  Companion_getInstance_4 as Companion_getInstanceq9bpui01g1r5,
  Companion_getInstance_7 as Companion_getInstance2jgeip11toh8t,
  Companion_instance_11 as Companion_instancepvrn1rfebb8p,
  Companion_getInstance_6 as Companion_getInstance3moa2zk1h7b6i,
  Companion_getInstance_3 as Companion_getInstance11brt9mg8u6o3,
  Companion_getInstance_8 as Companion_getInstance4ivu8l0d0qdj,
  Companion_instance_1 as Companion_instance142n4cw0cx0vy,
  Companion_instance_2 as Companion_instance2f9qz66nhm21c,
  Companion_instance_10 as Companion_instancevoo46bgnocyv,
  Companion_getInstance_5 as Companion_getInstance2yo4wmuc8aop,
  Companion_getInstance as Companion_getInstance1os58gbbjei8z,
};
//endregion

//# sourceMappingURL=WebAuthN.mjs.map
